/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

export const nowPlayingPages = {
    FullPlayerPanel: () => import('@/transport/FullPlayerPanel'),
    NowPlayingPage: () => import('@/nowPlaying/NowPlayingPage'),
    PodcastStageTransport: () => import('@/transport/PodcastStageTransport'),
}
